import React, { useState, useCallback } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Select from '../Select';
import s from './AddWrapping.scss';
import Clickable from '../Clickable';
import List from '../List';
import giftwrap from '../../assets/images/giftwrap.png';
import NumericInput from '../NumericInput';
import Modal from '../Modal';
import Grid from '../Grid';
import Label from '../Label';
import Price from '../Price';

const AddWrapping = ({
  intl: { locale },
  modalProps,
  inputProps,
  submitProps,
  onAdd,
  wrapping: {
    data: { items = [] },
  },
  defaultWrapping,
  wrappingDescription,
  wrappingDetails,
}) => {
  const [quantity, setQuantity] = useState(defaultWrapping?.quantity || 1);
  const [selectedWrappingId, setSelectedWrappingId] = useState(
    defaultWrapping?.id,
  );
  const onSave = useCallback(() => {
    if (selectedWrappingId) {
      onAdd(quantity === 0 ? null : { quantity, id: selectedWrappingId });
    }
  }, [selectedWrappingId, quantity, onAdd]);

  const { wrappingPriceNoTax, wrappingPriceCurrency } =
    items.find(({ id }) => id === selectedWrappingId) || {};

  return (
    <Modal maxWidth {...modalProps}>
      <div className={s.root}>
        <Grid
          noValidate
          container
          spacing="fluid"
          justify="center"
          onSubmit={event => event.preventDefault()}
          className={s.wrappingContainer}
        >
          <Grid item className={s.imageBox}>
            <img className={s.image} src={giftwrap} alt="Gift wrapping" />
          </Grid>
          <Grid item sm={14} md={14}>
            <List
              container
              component="div"
              direction="column"
              alignItems="flex-start"
              spacing={12}
            >
              <List item container direction="column" alignItems="flex-start">
                {wrappingDescription && <Label>{wrappingDescription}</Label>}

                {wrappingDetails && (
                  <Label bold>
                    {`${wrappingDetails}: `}
                    <Price
                      value={wrappingPriceNoTax}
                      currency={wrappingPriceCurrency}
                    />
                  </Label>
                )}
              </List>
              <List item>
                <Select
                  options={items.map(({ id, labels }) => ({
                    label: labels[locale],
                    value: id,
                  }))}
                  basic
                  value={selectedWrappingId}
                  onChange={({ target: { value } }) =>
                    setSelectedWrappingId(value)
                  }
                />
              </List>
              <List item>
                <NumericInput
                  name="quantity"
                  showLabel
                  {...inputProps}
                  value={quantity}
                  minNumber={0}
                  onChange={e => setQuantity(e.target.value)}
                />
              </List>
            </List>
          </Grid>
        </Grid>
        <div className={s.wrappingContainer}>
          <Clickable primary type="submit" {...submitProps} onClick={onSave} />
        </div>
      </div>
    </Modal>
  );
};

AddWrapping.defaultProps = {
  inputProps: {},
  defaultWrapping: null,
  wrappingDescription: null,
  wrappingDetails: null,
};

AddWrapping.propTypes = {
  modalProps: PropTypes.shape().isRequired,
  inputProps: PropTypes.shape(),
  submitProps: PropTypes.shape().isRequired,
  onAdd: PropTypes.func.isRequired,
  wrapping: PropTypes.shape().isRequired,
  defaultWrapping: PropTypes.shape({
    id: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
  }),
  wrappingDetails: PropTypes.string,
  wrappingDescription: PropTypes.string,
  intl: PropTypes.shape().isRequired,
};

const mapState = ({ wrapping }) => ({
  wrapping,
});

export default compose(
  withStyles(s),
  injectIntl,
  connect(mapState),
)(AddWrapping);
